import React, { memo } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';
import Frame from '../Frame';

import styles from './styles.js';

const useStyles = createUseStyles(styles, 'CenteredLayout');

const CenteredLayout = ({ iframeURL, lang, children }) => {
    const classes = useStyles();
    const url =
        `${iframeURL}?lang=${lang.toUpperCase()}` || 'https://try.forcemanager.net/app-login/';

    return (
        <div className={classes.root}>
            {iframeURL && (
                <div className={classes.frame}>
                    <Frame url={url} />
                </div>
            )}
            <div className={classes.children}>{children}</div>
        </div>
    );
};

export default memo(CenteredLayout);
